import React from 'react'
import {
  convertMetersToKiloMeters,
  convertMetersToMiles
} from '../../../utils/lengthConversions'
import { isCenterAmerican } from '../../../domain/center'
import { isNonEmptyObject, isNonEmptyString } from '../../../utils/checks'

export const NearbyCentersLabel = ({
  locationLabel,
  rankingInfo,
  pageTitle,
  refinementLocation
}) => {
  if (!isNonEmptyObject(rankingInfo) || !isNonEmptyString(locationLabel)) {
    return null
  }

  const location =
    pageTitle === 'browse' ? refinementLocation?.split(',')[0] : pageTitle

  if (!location) {
    return null
  }

  const distance =
    rankingInfo.geoDistance || rankingInfo?.matchedGeoLocation?.distance

  const distanceInMiles = convertMetersToMiles(distance)

  if (!distanceInMiles) {
    return null
  }

  return (
    <div className={'flex text-sm text-gray-800'}>
      {isCenterAmerican(locationLabel) ? (
        <p className="location-check inherit">
          {convertMetersToMiles(distance).toString()} miles from {location}
        </p>
      ) : (
        <p>
          {convertMetersToKiloMeters(distance)} km from {location}
        </p>
      )}
    </div>
  )
}
